(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const variant = JSON.parse(q('[data-variant]').textContent);
    const route = window.Shopify?.routes?.root || '/';
    const currency = root.dataset.currency || 'USD';
    const code = root.dataset.code;
    const subtotal = () => variant.price * quantity - (currency === 'USD' && quantity >= 2 ? 100 * quantity : 0);
    const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency}).format(cents / 100);
    const quantities = all('[data-bundle-quantity]').map(input => Number(input.value));
    const max = variant.tracked && variant.policy !== 'continue' ? Math.max(0, variant.stock) : Math.max(...quantities);
    const saved = history.state?.tenloveEntrywayRack;
    let quantity = saved?.product === root.dataset.product && quantities.includes(saved.quantity) && saved.quantity <= max ? saved.quantity : 1;
    let busy = false;
    const allowed = () => variant.available && quantities.includes(quantity) && quantity <= max;
    const update = () => {
      all('[data-bundle-quantity]').forEach(input => {
        const count = Number(input.value);
        input.checked = count === quantity;
        input.closest('label').classList.toggle('is-selected', input.checked);
        input.disabled = busy || !variant.available || count > max;
      });
      q('[data-quantity]').value = quantity;
      q('[data-express-quantity]').value = quantity;
      q('[data-express]').hidden = busy || !allowed();
      q('[data-total]').textContent = money(subtotal());
      q('[data-sticky-total]').textContent = money(subtotal());
      const compare = q('[data-sticky-compare]');
      compare.hidden = !(variant.compareAt > variant.price);
      if (!compare.hidden) compare.textContent = money(variant.compareAt * quantity);
      q('[data-sticky-title]').textContent = `${quantity} ${quantity === 1 ? 'rack' : 'racks'}`;
      q('[data-buy-label]').textContent = busy ? 'Adding...' : allowed() ? 'Buy Now' : 'Sold out';
      q('[data-sticky-buy]').textContent = busy ? 'Adding...' : allowed() ? 'Buy Now \u2192' : 'Sold out';
      for (const sel of ['[data-buy]','[data-add]','[data-sticky-buy]']) q(sel).disabled = busy || !allowed();
      const original = q('[data-track] img');
      q('[data-sticky-images]').replaceChildren(...Array.from({length:quantity}, () => {
        const img = document.createElement('img');
        img.src = original.src; img.alt = original.alt || 'Entryway rack photo'; img.width = 40; img.height = 46; return img;
      }));
      history.replaceState({...history.state,tenloveEntrywayRack:{product:root.dataset.product,quantity}}, '');
    };
    all('[data-bundle-quantity]').forEach(input => input.addEventListener('change', () => {
      if (busy || input.disabled) return;
      quantity = Number(input.value); q('[data-error]').hidden = true; update();
    }));
    const add = async checkout => {
      if (busy || !allowed()) return;
      busy = true; q('[data-error]').hidden = true; update();
      const controller = new AbortController(), timeout = setTimeout(() => controller.abort(),20000);
      try {
        const response = await fetch(`${route}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:controller.signal,body:JSON.stringify({items:[{id:variant.id,quantity}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Please check your selection and try again.');
        location.assign(`${route}${checkout ? 'checkout' : 'cart'}`);
      } catch (error) {
        q('[data-error]').textContent = error.name === 'AbortError' || error instanceof TypeError ? 'We could not confirm your cart update. Please check your cart before trying again.' : error.message;
        q('[data-error]').hidden = false; busy = false; update();
      } finally {clearTimeout(timeout);}
    };
    q('[data-rack-form]').addEventListener('submit', event => {event.preventDefault();event.stopImmediatePropagation();add(true);},true);
    q('[data-add]').addEventListener('click', () => add(false));
    q('[data-sticky-buy]').addEventListener('click', () => add(true));
    window.addEventListener('pageshow', () => {busy = false; update();});
    const coupon = q('[data-coupon]'), slot = q('[data-coupon-slot]');
    const key = `tenlove-entryway-coupon:${root.dataset.product}`;
    try {coupon.hidden = sessionStorage.getItem(key) === 'dismissed';} catch (_) {}
    const measure = () => {slot.hidden = coupon.hidden;slot.style.height = `${Math.ceil(coupon.getBoundingClientRect().height)}px`;};
    const resize = new ResizeObserver(measure);resize.observe(coupon);measure();
    const pin = new IntersectionObserver(entries => coupon.classList.toggle('is-pinned',!coupon.hidden && entries[0].boundingClientRect.top < 0));pin.observe(slot);
    q('[data-dismiss]').addEventListener('click', () => {coupon.hidden = true;coupon.classList.remove('is-pinned');try {sessionStorage.setItem(key,'dismissed');} catch (_) {} measure();q('[data-track]').focus({preventScroll:true});});
    const copy = async () => {
      try {await navigator.clipboard.writeText(code);q('[data-copy-label]').textContent = 'Copied';}
      catch (_) {q('[data-copy-label]').textContent = 'Use at checkout';}
      q('[data-copy-status]').textContent = `Enter ${code} at checkout for 15% off your racks. The two-rack saving combines with this code. Shipping is not discounted; tax is calculated at checkout.`;
    };
    q('[data-copy-code]').addEventListener('click',copy);q('[data-copy-code-inline]').addEventListener('click',copy);
    const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    const track = q('[data-track]'), slides = all('.tlr-slide');let slide = 0;
    const videos = all('[data-rack-video]');
    const videoInView = new Set(), manualPause = new WeakSet(), automaticPause = new WeakSet(), pendingPlay = new WeakSet();
    const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
    const pauseVideo = video => {if (!video.paused) {automaticPause.add(video);video.pause();}};
    const pauseVideos = () => videos.forEach(pauseVideo);
    const autoplayVisible = () => {
      if (document.hidden || motionPreference.matches || navigator.connection?.saveData) return;
      if (videos.some(video => !video.paused && videoInView.has(video))) return;
      const candidate = videos.find(video => {
        const parent = video.closest('.tlr-slide');
        return video.hasAttribute('data-video-autoplay') && videoInView.has(video) && !manualPause.has(video) && !video.error && (!parent || parent === slides[slide]);
      });
      if (!candidate || pendingPlay.has(candidate)) return;
      pendingPlay.add(candidate);
      candidate.play().catch(error => {
        if (error.name !== 'AbortError') manualPause.add(candidate);
      }).finally(() => pendingPlay.delete(candidate));
    };
    videos.forEach(video => {
      const player = video.closest('[data-video-player]');
      const play = player.querySelector('[data-video-play]');
      const error = player.querySelector('[data-video-error]');
      video.muted = true;
      play.hidden = false;
      const showError = () => {error.hidden = false; play.hidden = false;};
      play.addEventListener('click', () => {
        manualPause.delete(video);
        error.hidden = true;
        video.play().catch(showError);
      });
      video.addEventListener('play', () => {
        manualPause.delete(video);
        videos.filter(other => other !== video).forEach(pauseVideo);
        error.hidden = true; play.hidden = true;
      });
      video.addEventListener('pause', () => {
        if (automaticPause.has(video)) automaticPause.delete(video);
        else manualPause.add(video);
        play.hidden = false;
      });
      video.addEventListener('ended', () => {play.hidden = false;});
      video.addEventListener('error', showError);
    });
    // Play silent clips only in view; preserve a visitor's deliberate pause.
    const videoVisibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) videoInView.add(entry.target);
        else {videoInView.delete(entry.target);pauseVideo(entry.target);}
      });
      autoplayVisible();
    }, {threshold:[0,0.25]});
    videos.forEach(video => videoVisibility.observe(video));
    const pauseWhenHidden = () => {if (document.hidden) pauseVideos();else autoplayVisible();};
    const motionChanged = () => {if (motionPreference.matches) pauseVideos();else autoplayVisible();};
    motionPreference.addEventListener?.('change',motionChanged);
    document.addEventListener('visibilitychange', pauseWhenHidden);
    window.addEventListener('pagehide', pauseVideos);
    window.addEventListener('pageshow',autoplayVisible);
    const go = index => track.scrollTo({left:Math.max(0,Math.min(slides.length - 1,index))*track.clientWidth,behavior:behavior()});
    const sync = () => {slide = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));all('[data-thumb]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.thumb) === slide)));videos.forEach(video => {const parent = video.closest('.tlr-slide');if (parent && parent !== slides[slide]) pauseVideo(video);});autoplayVisible();};
    all('[data-thumb]').forEach(button => button.addEventListener('click',() => go(Number(button.dataset.thumb))));
    track.addEventListener('scroll',sync,{passive:true});
    track.addEventListener('keydown',event => {if (event.target.closest('[data-video-player]')) return; if (['ArrowLeft','ArrowRight'].includes(event.key)) {event.preventDefault();go(slide+(event.key === 'ArrowRight' ? 1 : -1));}});
    const mini = q('[data-mini-track]');
    q('[data-mini-prev]').addEventListener('click',() => mini.scrollBy({left:-mini.clientWidth,behavior:behavior()}));
    q('[data-mini-next]').addEventListener('click',() => mini.scrollBy({left:mini.clientWidth,behavior:behavior()}));
    const reviewTrack = q('[data-review-track]');
    const reviewStep = () => (reviewTrack.querySelector('article')?.getBoundingClientRect().width || reviewTrack.clientWidth) + Number.parseFloat(getComputedStyle(reviewTrack).gap || 0);
    q('[data-review-prev]').addEventListener('click',() => reviewTrack.scrollBy({left:-reviewStep(),behavior:behavior()}));
    q('[data-review-next]').addEventListener('click',() => reviewTrack.scrollBy({left:reviewStep(),behavior:behavior()}));
    const sticky = new IntersectionObserver(entries => {q('[data-sticky]').hidden = entries[0].boundingClientRect.top >= 0;});sticky.observe(q('[data-buy]'));
    const dialog = q('[data-lightbox]');
    all('[data-enlarge]').forEach(button => button.addEventListener('click',() => {
      const img = button.querySelector('img');q('[data-lightbox-image]').src = img.src;q('[data-lightbox-image]').alt = img.alt;
      const caption = button.closest('figure')?.querySelector('figcaption');
      q('[data-lightbox-caption]').textContent = caption ? [...caption.childNodes].map(node => node.textContent.trim()).filter(Boolean).join(' · ') : img.alt || 'Entryway rack photograph';dialog.showModal();
    }));
    q('[data-close]').addEventListener('click',() => dialog.close());dialog.addEventListener('click',event => {if (event.target === dialog) dialog.close();});
    document.addEventListener('shopify:section:unload',event => {if (event.target.contains(root)) {resize.disconnect();pin.disconnect();sticky.disconnect();videoVisibility.disconnect();pauseVideos();motionPreference.removeEventListener?.('change',motionChanged);document.removeEventListener('visibilitychange',pauseWhenHidden);window.removeEventListener('pagehide',pauseVideos);window.removeEventListener('pageshow',autoplayVisible);}});
    update();sync();
  };
  document.querySelectorAll('[data-entryway-rack]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-entryway-rack]').forEach(init));
})();
